var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 140,
    viewBox: "0 0 109 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2559 137.069C77.2976 131.907 71.9901 101.564 55.4012 69.2965C38.8123 37.0292 17.2239 15.0565 7.18214 20.219C-2.85958 25.3816 2.44797 55.7244 19.0369 87.9917C35.6258 120.259 57.2142 142.232 67.2559 137.069Z",
    stroke: "#34D8D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6337 128.135C94.6754 122.973 89.3678 92.6297 72.7789 60.3624C56.19 28.0951 34.6016 6.12243 24.5599 11.285C14.5182 16.4475 19.8257 46.7904 36.4146 79.0576C53.0035 111.325 74.5919 133.298 84.6337 128.135Z",
    stroke: "#34D8D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.018 119.198C112.059 114.035 106.752 83.6923 90.163 51.4251C73.5741 19.1578 51.9857 -2.81492 41.944 2.34763C31.9023 7.51017 37.2098 37.853 53.7987 70.1203C70.3877 102.388 91.9761 124.36 102.018 119.198Z",
    stroke: "#34D8D8",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape6);
export default __webpack_public_path__ + "static/media/shape6.368697ce904820541d9214ee829b6219.svg";
export { ForwardRef as ReactComponent };